import { yupResolver } from '@hookform/resolvers'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { ItemVoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomItemTextField'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { Grid, MenuItem, TextField } from '@material-ui/core'
import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import BigNumber from 'bignumber.js'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  RecordStatus,
  useGetClassificationCodeLazyQuery,
  useGetDocumentDateValidationQuery,
  useGetTaxEffectiveDateQuery,
  useGetTaxSchemeQuery,
  useGetUomExchangeListLazyQuery,
  useGetDepartmentListingByItemIdLazyQuery,
  useGetGlCompanyPolicyQuery,
} from 'generated/graphql'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import * as yup from 'yup'
import {
  baseAmount,
  getTotalAmtWithQty,
} from '../../ARAPModule/Helper/AmountCalculation'
import { PaginatedAutocomplete } from '@ifca-root/react-component/src/containers/ComponentModule/PaginatedAutoComplete'
import { useGetGeneralPurchasePolicyQuery } from '@account-root/procurement-react/src/generated/graphql'
import { DefaultDepartmentHandlerService } from 'containers/GeneralLedgerModule/Hooks/DefaultDepartment/DefaultDepartmentService'

interface ItemProps {
  Quantity: number
  ExpenseItemID: string
  UOMID: string
  Amount: number
  UnitPrice: number
  DocAmt: number
  TaxSchemeID: string
  TaxAmt: number
  TaxRate: number
  CostCentreID: string
  Remark: string
  einvoice_classification_code_id: string
}

const defaultVal: any = {
  ExpenseItemID: '',
  Amount: 0,
  DocAmt: 0,
  UnitPrice: 0,
  TaxSchemeID: '',
  TaxAmt: 0,
  TaxRate: 0,
  CostCentreID: '',
  Remark: '',
  UOMID: '',
  Quantity: 0,
  einvoice_classification_code_id: '',
}

export const ItemDialog = (props: any) => {
  const {
    companyID,
    openItemDialog,
    setOpenItemDialog,
    itemData,
    ExpenseItemLoading,
    getItemByCompany,
    title,
    watch,
    detailMode,
    menu,
    selectedTax,
    setSelectedTax,
    primaryItemKey,
    fetchExpenseItem,
    totalLength,
    setOptions,
    selfBillStatus,
    EInvoiceStarted,
    creditorAcc,
  } = props

  const ItemSchema = yup.object().shape({
    ExpenseItemID: CommonYupValidation.requireField('Item is required'),
    TaxSchemeID: CommonYupValidation.requireField('Tax Code is required'),
    UOMID: yup.string().required(SystemMsgs.uom()),
    CostCentreID: CommonYupValidation.requireField('Department is required'),
    Quantity: yup
      .number()
      .transform((originalValue, originalObject) => {
        if (originalValue?.length > 3) {
          return parseInt(originalObject.replace(/,/g, ''))
        } else {
          return parseFloat(originalObject)
        }
      })
      .min(0.01, 'Quantity must be at least 0.01')
      .required('Quantity must be at least 0.01'),
    // UnitPrice: yup.string().when('ExpenseItemID', {
    //   is: value =>
    //     getItemByCompany?.find(x => x?.ExpenseItemID === value)?.IsSystem ===
    //     true
    //       ? false
    //       : true,
    //   then: yup
    //     .number()
    //     .transform((originalValue, originalObject) => {
    //       if (originalValue?.length > 3) {
    //         return parseInt(originalObject.replace(/,/g, ''))
    //       } else {
    //         return parseFloat(originalObject)
    //       }
    //     })
    //     .min(0.0001, 'Quantity must be at least 0.0001')
    //     .required('Unit Price is required'),
    // }),

    UnitPrice: yup
      .number()
      .transform((originalValue, originalObject) => {
        if (originalValue?.length > 3) {
          return parseInt(originalObject.replace(/,/g, ''))
        }
        return parseFloat(originalObject)
      })
      .when('ExpenseItemID', {
        is: value =>
          getItemByCompany?.find(x => x?.ExpenseItemID === value)?.IsSystem ===
          true,
        then: schema => schema.notRequired(),
        otherwise: schema =>
          schema
            .min(0.0001, 'Unit Price must be at least 0.0001')
            .required('Unit Price is required'),
      }),

    Remark: CommonYupValidation.requireField('Remark is required'),
    ...(!!selfBillStatus && EInvoiceStarted
      ? {
          einvoice_classification_code_id: CommonYupValidation.requireField(
            SystemMsgs.ClassificationCode()
          ),
        }
      : null),
  })
  const {
    handleSubmit: handleItemSubmit,
    register: itemRegister,
    setValue: setValueItem,
    watch: itemWatch,
    errors: itemErrors,
    control: itemControl,
    clearErrors: clearErrorsItem,
    getValues: getValuesItem,
    reset: itemReset,
  } = useForm<ItemProps>({
    defaultValues: {
      ExpenseItemID: !!menu ? menu?.obj?.ExpenseItemID : '',
      Amount: !!menu ? menu?.obj?.Amount : 0,
      UnitPrice: !!menu ? menu?.obj?.UnitPrice : 0,
      CostCentreID: !!menu ? menu?.obj?.CostCentreID : '',
      DocAmt: !!menu ? menu?.obj?.DocAmt : 0,
      TaxSchemeID: !!menu ? menu?.obj?.TaxSchemeID : '',
      TaxAmt: 0,
      TaxRate: 0,
      Remark: !!menu ? menu?.obj?.Remark : '',
      einvoice_classification_code_id: !!menu
        ? menu?.obj?.einvoice_classification_code_id
        : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(ItemSchema),
  })

  const itemEditData =
    !!menu && menu?.obj?.ExpenseItemID
      ? getItemByCompany?.filter(
          item => item?.ExpenseItemID === menu?.obj?.ExpenseItemID
        )[0]
      : null

  const [cost, setCost] = useState<any>(
    detailMode === 'edit' ? menu?.obj?.UnitPrice : 0
  )

  const [qty, setQty] = useState(
    detailMode === 'edit' ? menu?.obj?.Quantity : 0
  )

  const [uomID, setUomID] = useState('')

  const [refresh, setRefresh] = useState(!!menu?.obj?.ExpenseItemID)
  const [isSaveNewClicked, setIsSaveNewClicked] = useState(false)

  const [taxAmt, setTaxAmt] = useState(
    detailMode === 'edit' ? menu?.obj?.TaxAmt : 0
  )

  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  const [itemRecord, setItemRecord] = useState(false)
  const [itemVoiceRemark, setItemVoiceRemark] = useState('')

  const [mountDefVal, setMountDefVal] = useState(!!menu?.obj)
  const [useDefaultDept, setUseDefaultDept] = useState(false)

  const [itemColor, setItemColor] = useState(
    getItemByCompany?.find(
      item => item?.ExpenseItemID === menu?.obj?.ExpenseItemID
    )?.IsInventory === true
      ? 'darkblue'
      : ''
  )

  useEffect(() => {
    getItemByCompany?.find(
      item => item?.ExpenseItemID === menu?.obj?.ExpenseItemID
    )?.IsInventory === true && setItemColor('darkblue')
  }, [getItemByCompany])

  const docAmt = getTotalAmtWithQty(qty, cost, taxAmt)

  const [classificationCodeID, setClassificationCodeID] = useState(
    !!menu ? menu?.obj?.einvoice_classification_code_id : null
  )
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  // e-Invoice Query
  const [
    loadClassificationCode,
    {
      loading: ClassificationCodeLoading,
      data: { getClassificationCode } = { getClassificationCode: [] },
    },
  ] = useGetClassificationCodeLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: data => {
      if (!!classificationCodeID) {
        itemRegister('einvoice_classification_code_id')
        setValueItem(
          'einvoice_classification_code_id',
          data.getClassificationCode.filter(
            x => x?.id === classificationCodeID
          )[0].id
        )
      }
    },
  })

  const { loading: GLCompanyLoading } = useGetGlCompanyPolicyQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: companyID },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
    onCompleted: ({ getGLCompanyPolicy }) => {
      setUseDefaultDept(getGLCompanyPolicy[0]?.DefaultDepartmentBalanceSheetCOA)
    },
  })

  const {
    loading: GPPolicyLoading,
    data: { getGeneralPurchasePolicy } = { getGeneralPurchasePolicy: [] },
  } = useGetGeneralPurchasePolicyQuery({
    fetchPolicy: 'network-only',
    variables: { AccountID: user?.accountID },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
  })

  const classificationCode = !!classificationCodeID
    ? getClassificationCode?.filter(x => x?.id === classificationCodeID)[0]
        ?.classificationCode
    : getClassificationCode?.filter(
        x => x?.id === menu?.obj?.einvoice_classification_code_id
      )[0]?.classificationCode

  const classificationDescription = !!classificationCodeID
    ? getClassificationCode?.filter(x => x?.id === classificationCodeID)[0]
        ?.description
    : getClassificationCode?.filter(
        x => x?.id === menu?.obj?.einvoice_classification_code_id
      )[0]?.description

  // Tax
  const {
    loading: TaxSchemeLoading,
    data: { getTaxScheme } = { getTaxScheme: [] },
  } = useGetTaxSchemeQuery({
    variables: { RecordStatus: RecordStatus.Active },
    onCompleted: () => {
      if (detailMode === 'edit') {
        setSelectedTax(
          taxScheme?.find(x => x?.TaxSchemeID === menu?.obj?.TaxSchemeID)
        )

        // Force load Classification Code on edit
        loadClassificationCode()
      }
    },
  })

  const [
    fetchUOM,
    {
      loading: uomExcLoading,
      data: { getUOMExchangeList } = { getUOMExchangeList: [] },
    },
  ] = useGetUomExchangeListLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setValueItem('UOMID', null)
    },
    onCompleted: data => {
      if (!!uomID) {
        itemRegister('UOMID')
        setValueItem(
          'UOMID',
          data.getUOMExchangeList.filter(x => x?.uomid === uomID)[0].uomid
        )
      }
    },
  })

  /* -------------------------------------------- */
  /*                   DEF DEPT                   */
  /* -------------------------------------------- */
  const [
    fetchDepartmentListingByItemID,
    {
      loading: HandlerLoading,
      called: HandlerCalled,
      data: { getDepartmentListingByItemID } = {
        getDepartmentListingByItemID: [],
      },
    },
  ] = useGetDepartmentListingByItemIdLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: ({ getDepartmentListingByItemID }) => {
      DefaultDepartmentHandlerService.InitializeDepartmentValueInEditMode({
        DepartmentListingArray: getDepartmentListingByItemID,
        DefaultDepartmentPolicy: useDefaultDept, // nullable; used for GL Department Policy checking
        EditData: itemEditData,
        SetValue: setValueItem,
        MountDefVal: mountDefVal, // to avoid overriding costcentreid on another api call
      })
    },
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(`${errorMessage}"`)
    },
  })

  const isDefaultChecking: boolean =
    HandlerCalled === true
      ? !!(
          getDepartmentListingByItemID?.length === 1 &&
          !!getDepartmentListingByItemID[0]?.IsDefault
        )
      : false

  const disableDeptController: boolean = !!(
    useDefaultDept === true && isDefaultChecking === true
  )
  //============================================================================

  const {
    loading: DocDateValidationLoading,
    data: { getDocumentDateValidation } = { getDocumentDateValidation: [] },
  } = useGetDocumentDateValidationQuery({ fetchPolicy: 'network-only' })

  //TaxEffectiveDate
  const {
    loading: TaxEffectiveDateLoading,
    data: { getTaxEffectiveDate } = { getTaxEffectiveDate: [] },
  } = useGetTaxEffectiveDateQuery({ fetchPolicy: 'network-only' })

  const taxScheme: any = getTaxScheme
  // To get list of Tax Code that has been effective //
  const taxEffectiveDate: any = new Date(
    new Date().getTime() + 24 * 60 * 60 * 1000
  )
    .toISOString()
    .slice(0, 10)

  const taxSchemeInput: any = getTaxScheme?.filter(
    el =>
      el?.AccTaxClass === 'INPUT' &&
      el?.TaxEffective.map(y => y?.Date) <= taxEffectiveDate
  )

  const taxCodeName = getTaxScheme?.filter(
    x => x?.TaxSchemeID === selectedTax?.TaxSchemeID
  )[0]?.Code

  const taxCodeRate = amtStr(
    getTaxScheme?.filter(x => x?.TaxSchemeID === selectedTax?.TaxSchemeID)[0]
      ?.LatestTax?.Rate
  )

  const costCentreCode =
    itemWatch('CostCentreID') !== undefined
      ? getDepartmentListingByItemID.filter(
          x => x?.CostCentreID === itemWatch('CostCentreID')
        )[0]?.Code
      : getDepartmentListingByItemID.filter(
          x => x?.CostCentreID === menu?.obj?.CostCentreID
        )[0]?.Code

  const itemName =
    itemWatch('ExpenseItemID') !== undefined
      ? getItemByCompany?.filter(
          x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
        )[0]?.ItemName
      : getItemByCompany?.filter(
          x => x?.ExpenseItemID === menu?.obj?.ExpenseItemID
        )[0]?.ItemName

  const roundTo2Decimals = (num: number) => {
    return parseFloat(new BigNumber(num).toFixed(2))
  }

  const onSubmit = (data, docAmt, qty, unitPrice, amount, index, isSaveNew) => {
    if (detailMode === 'add') {
      itemData.push({
        Sequence: itemData?.length + 1,
        ExpenseItemID: data?.ExpenseItemID,
        CostCentreID: data?.CostCentreID,
        UnitPrice: unitPrice,
        Amount: amount,
        Quantity: qty,
        UOMID: uomID,
        TaxSchemeID: data?.TaxSchemeID,
        TaxCode: taxCodeName,
        TaxRate: taxCodeRate,
        ExpenseItemName: itemName,
        CostCentreCode: costCentreCode,
        TaxAmt: parseFloat(taxAmt),
        DocAmt: roundTo2Decimals(docAmt),
        Remark: data?.Remark,
        einvoice_classification_code_id:
          !!selfBillStatus && EInvoiceStarted ? classificationCodeID : null,
        ClassificationCode:
          !!selfBillStatus && EInvoiceStarted ? classificationCode : null,
        ClassificationDescription:
          !!selfBillStatus && EInvoiceStarted
            ? classificationDescription
            : null,
      })
    } else {
      let existingItemData = itemData[index]

      itemData[index] = {
        Sequence: itemData?.Sequence ?? index + 1,
        [`${primaryItemKey}`]: itemData[index]?.[`${primaryItemKey}`],
        ...(!!menu?.obj?.DOItemID
          ? { DOItemID: menu?.obj?.DOItemID }
          : !!menu?.obj?.GRTNItemID
          ? { GRTNItemID: menu?.obj?.GRTNItemID }
          : null),
        ExpenseItemID: data?.ExpenseItemID,
        CostCentreID: data?.CostCentreID,
        UnitPrice: unitPrice,
        Amount: amount ?? docAmt - existingItemData?.TaxAmt,
        ExpenseItemName: itemName,
        CostCentreCode: costCentreCode,
        Quantity: qty,
        UOMID: uomID,
        TaxRate: taxCodeRate ?? existingItemData?.TaxRate,
        TaxCode: taxCodeName,
        TaxSchemeID: data?.TaxSchemeID,
        TaxAmt: parseFloat(taxAmt),
        DocAmt: docAmt,
        Remark: data?.Remark,
        einvoice_classification_code_id:
          !!selfBillStatus && EInvoiceStarted
            ? data?.einvoice_classification_code_id
            : null,
        ClassificationCode:
          !!selfBillStatus && EInvoiceStarted ? classificationCode : null,
        ClassificationDescription:
          !!selfBillStatus && EInvoiceStarted
            ? classificationDescription
            : null,
      }
    }

    setOptions([])
    if (!isSaveNew) {
      fetchDepartmentListingByItemID({
        variables: { CompanyID: companyID, ExpenseItemID: null },
      })
      setOpenItemDialog(false)
    } else {
      fetchDepartmentListingByItemID({
        variables: { CompanyID: companyID, ExpenseItemID: null },
      })
      setValueItem('ExpenseItemID', null)
      setRefresh(true)
      setIsSaveNewClicked(true)
      itemReset(defaultVal)
      fetchExpenseItem()
    }
  }

  const closeFooterOption = {
    displayText: 'Close',
    props: {
      onClick: () => {
        setOptions([])
        setOpenItemDialog(false)
      },
      variant: 'contained',
      color: 'primary',
    },
  }

  const readOnly = () => {
    if (menu?.obj?.DOItemID || menu?.obj?.GRTNItemID) return true
    else return false
  }

  const disableDepartmentController: () => boolean = () => {
    return !!(
      getDepartmentListingByItemID?.length === 1 &&
      getDepartmentListingByItemID[0]?.IsDefault === true
    )
  }

  // ======== Functions for Expense Item ========= //
  const handleExpenseItemChange = ExpenseItemID => {
    setValueItem('ExpenseItemID', ExpenseItemID)
    // this is to get tax after select the expense item
    let defTax = getItemByCompany?.filter(
      x => x?.ExpenseItemID === ExpenseItemID
    )[0]?.TaxSchemeID

    const uom = getItemByCompany?.find(x => x?.ExpenseItemID === ExpenseItemID)
      ?.UOMID
    setUomID(uom)

    fetchUOM({ variables: { UOMID: uom } })
    let selectTax = taxScheme?.find(x => x?.TaxSchemeID === defTax)
    setValueItem('TaxSchemeID', defTax)
    setSelectedTax(selectTax)
    clearErrorsItem('ExpenseItemID')

    const taxEffectiveDate: any = watch('DocDate')
      ? new Date(new Date(watch('DocDate')).getTime() + 24 * 60 * 60 * 1000)
          .toISOString()
          .slice(0, 10)
      : null

    const taxAmount = new BigNumber(
      selectTax?.LatestTax === null
        ? selectTax?.TaxEffective.reduce((a, b) => {
            return new Date(a.Date) > new Date(b.Date) ? a : b
          })?.Rate
        : selectTax?.TaxEffective?.filter(
            x => new Date(x?.Date) <= new Date(taxEffectiveDate)
          ).reduce((a, b) => {
            return new Date(a.Date) > new Date(b.Date) ? a : b
          }, 0)?.Rate
    )
      .dividedBy(100)
      .multipliedBy(cost)
      .multipliedBy(qty)
      .toNumber()
    setTaxAmt(taxAmount)
    setValueItem('TaxAmt', taxAmount)

    let ccID = creditorAcc[0]?.einvoice_classification_code_id

    if (selfBillStatus && EInvoiceStarted) {
      loadClassificationCode()
      itemRegister('einvoice_classification_code_id')
      setClassificationCodeID(ccID)
      setValueItem('einvoice_classification_code_id', ccID)
    }
  }

  const handleQtyChange = event => {
    setQty(event.value)
    setValueItem('Quantity', event?.value)
  }

  // Autoset tax after select tax amount
  useEffect(() => {
    if (!!selectedTax) {
      setValueItem('TaxSchemeID', selectedTax?.TaxSchemeID)
      clearErrorsItem('TaxSchemeID')
    }
  }, [selectedTax])

  useEffect(() => {
    if (!!menu?.obj?.UOMID) {
      setUomID(menu?.obj?.UOMID)
      itemRegister('UOMID')
      fetchUOM({ variables: { UOMID: uomID ?? menu?.obj?.UOMID } })
    }
  }, [uomID])

  //UseEffect for ReadOnly
  useEffect(() => {
    if (menu?.obj?.ExpenseItemID) {
      fetchDepartmentListingByItemID({
        variables: {
          CompanyID: companyID,
          ExpenseItemID: menu?.obj?.ExpenseItemID,
        },
      })
    }
  }, [menu?.obj])

  const handleAmtChange = event => {
    setCost(parseFloat(event.value))
    setValueItem('UnitPrice', parseFloat(event.value))
    if (selectedTax) {
      setTaxAmt(
        new BigNumber(
          selectedTax?.LatestTax === null
            ? selectedTax?.TaxEffective?.reduce((a, b) => {
                return new Date(a.Date) > new Date(b.Date) ? a : b
              })?.Rate
            : selectedTax?.LatestTax?.Rate
        )
          .dividedBy(100)
          .multipliedBy(event?.floatValue)
          .multipliedBy(qty)
          .toNumber()
      )
      setValueItem('TaxAmt', taxAmt)
    }
  }

  const handleTaxChange = (event, taxEffectiveDate) => {
    setSelectedTax(taxScheme.find(x => x?.TaxSchemeID === event?.target?.value))
    setTaxAmt(
      (new BigNumber(
        taxScheme.filter(x => x?.TaxSchemeID === event?.target?.value)[0]
          .LatestTax === null
          ? taxScheme
              .filter(x => x?.TaxSchemeID === event?.target?.value)[0]
              ?.TaxEffective.reduce((a, b) => {
                return new Date(a.Date) > new Date(b.Date) ? a : b
              })?.Rate
          : taxScheme
              .filter(x => x?.TaxSchemeID === event?.target?.value)[0]
              ?.TaxEffective?.filter(
                x => new Date(x?.Date) <= new Date(taxEffectiveDate)
              )
              .reduce((a, b) => {
                return new Date(a.Date) > new Date(b.Date) ? a : b
              })?.Rate
      ).toNumber() /
        100) *
        // cost
        baseAmount(Number(qty), Number(cost))
    )
  }

  const handleTaxAmtChange = event => {
    setTaxAmt(event?.value)
  }

  useEffect(() => {
    if (!isNaN(taxAmt)) {
      setValueItem('TaxAmt', taxAmt)
      clearErrorsItem('TaxAmt')
    }
  }, [taxAmt])

  useEffect(() => {
    if (detailMode === 'edit') {
      let selectTax = taxScheme.find(
        x => x?.TaxSchemeID === menu?.obj?.TaxSchemeID
      )

      setSelectedTax(selectTax)
    }
    if (selfBillStatus && itemEditData) {
      loadClassificationCode()
      itemRegister('einvoice_classification_code_id')
      setClassificationCodeID(menu?.obj?.einvoice_classification_code_id)
    }
  }, [detailMode])

  useEffect(() => {
    if (isSaveNewClicked) {
      setRefresh(false)
      setIsSaveNewClicked(false)
    }
  }, [isSaveNewClicked])

  useEffect(() => {
    if (
      !!getItemByCompany?.find(
        x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
      )
    ) {
      setRefresh(false)
    }
  }, [getItemByCompany, menu])

  return (
    <>
      {HandlerLoading && <Loading />}
      {GPPolicyLoading && <Loading />}
      {TaxSchemeLoading && <Loading />}
      {ExpenseItemLoading && <Loading />}
      {TaxEffectiveDateLoading && <Loading />}
      {DocDateValidationLoading && <Loading />}
      {ClassificationCodeLoading && <Loading />}
      <CommonDialog
        fullWidth={true}
        open={openItemDialog}
        onClose={() => setOpenItemDialog(false)}
        sections={{
          header: { title, rightText: detailMode === 'edit' ? 'Edit' : 'New' },
          body: () => (
            <>
              <div className="content-container" style={{ marginTop: '-20px' }}>
                {!refresh && (
                  <Controller
                    render={({ onChange, value }) => {
                      const selectedItem = getItemByCompany?.find(
                        x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
                      )
                      return (
                        <PaginatedAutocomplete
                          // Important PaginatedAutocomplete props
                          // =====================================
                          searchVariable="searchValue" // Follow argument name in API (e.g. searchValue)
                          fetchMoreOptions={fetchExpenseItem}
                          setOptions={setOptions}
                          options={getItemByCompany || []}
                          customItemColor={itemColor} // For AP and GP
                          setCustomItemColor={setItemColor} // For AP and GP
                          totalLength={totalLength}
                          setValue={setValueItem}
                          name="ExpenseItemID"
                          optionsLoading={ExpenseItemLoading}
                          // =====================================
                          getOptionLabel={option => `${option?.ItemName}`}
                          fullWidth
                          disabled={readOnly() === true ? true : false}
                          onChange={(value, newValue: any, reason) => {
                            setRefresh(false)
                            setValueItem(
                              'ExpenseItemID',
                              newValue?.ExpenseItemID
                            )
                            setMountDefVal(false)
                            setValueItem('CostCentreID', null)
                            if (reason !== 'clear') {
                              handleExpenseItemChange(newValue?.ExpenseItemID)
                            }
                            fetchDepartmentListingByItemID({
                              variables: {
                                CompanyID: companyID,
                                ExpenseItemID: newValue?.ExpenseItemID,
                              },
                            })

                            if (newValue?.IsInventory === true) {
                              setItemColor('darkblue')
                            } else setItemColor('')
                          }}
                          renderOption={(props, option) => {
                            return props?.IsInventory === true ? (
                              <span style={{ color: 'darkblue' }}>
                                {props?.ItemName}
                              </span>
                            ) : (
                              <span>{props?.ItemName}</span>
                            )
                          }}
                          value={selectedItem}
                          label="Item"
                          renderInput={(params: any) => {
                            return (
                              <div>
                                <TextField
                                  {...params}
                                  required
                                  label="Item"
                                  variant="standard"
                                  fullWidth
                                  name="ExpenseItemID"
                                  disabled={readOnly() === true ? true : false}
                                  helperText={
                                    itemErrors?.ExpenseItemID?.message
                                  }
                                  error={
                                    itemErrors?.ExpenseItemID ? true : false
                                  }
                                  InputProps={{
                                    ...params?.InputProps,
                                    style: { color: itemColor },
                                  }}
                                />
                              </div>
                            )
                          }}
                        />
                      )
                    }}
                    name="ExpenseItemID"
                    autoComplete="off"
                    control={itemControl}
                    multiline={true}
                    fullWidth
                    margin="dense"
                    ref={itemRegister}
                    required
                    disabled={readOnly() === true ? true : false}
                    defaultValue={menu?.obj?.ExpenseItemID}
                    helperText={itemErrors?.ExpenseItemID?.message}
                    error={itemErrors?.ExpenseItemID ? true : false}
                  />
                )}

                {/* Classification e-Invoice */}
                {!ClassificationCodeLoading &&
                  selfBillStatus &&
                  EInvoiceStarted && (
                    <Controller
                      render={({ value, onChange }) => {
                        const defVal = getClassificationCode?.find(
                          x =>
                            x?.id ===
                            (classificationCodeID ??
                              menu?.obj?.einvoice_classification_code_id ??
                              menu?.obj?.ClassificationCodeID)
                        )

                        return (
                          <Autocomplete
                            options={
                              getClassificationCode
                                ?.filter(x =>
                                  x?.description.includes('Self-billed')
                                )
                                ?.sort((a, b) => {
                                  return a?.classificationCode.localeCompare(
                                    b.classificationCode
                                  )
                                }) || []
                            }
                            getOptionLabel={option =>
                              `${option?.classificationCode} | ${option?.description}`
                            }
                            fullWidth
                            disabled={!selfBillStatus ? true : false}
                            onChange={(value, newValue: any) => {
                              setClassificationCodeID(newValue?.id)
                              itemRegister('einvoice_classification_code_id')
                              setValueItem(
                                'einvoice_classification_code_id',
                                newValue?.id
                              )
                            }}
                            renderOption={(props, option) => {
                              return (
                                <>
                                  <div>
                                    <div>
                                      <span className="xsTitle">
                                        {props?.classificationCode}
                                      </span>
                                    </div>
                                    <div className="desc">
                                      {props?.description}
                                    </div>
                                  </div>
                                </>
                              )
                            }}
                            defaultValue={defVal}
                            renderInput={(params: any) => {
                              return (
                                <div>
                                  <TextField
                                    {...params}
                                    required
                                    label="Classification Code"
                                    variant="standard"
                                    fullWidth
                                    name="einvoice_classification_code_id"
                                    disabled={!selfBillStatus ? true : false}
                                    helperText={
                                      (itemWatch(
                                        'einvoice_classification_code_id'
                                      ) === '' ||
                                        itemWatch(
                                          'einvoice_classification_code_id'
                                        ) === undefined) &&
                                      itemErrors
                                        ?.einvoice_classification_code_id
                                        ?.message
                                    }
                                    error={
                                      (itemWatch(
                                        'einvoice_classification_code_id'
                                      ) === '' ||
                                        itemWatch(
                                          'einvoice_classification_code_id'
                                        ) === undefined) &&
                                      itemErrors?.einvoice_classification_code_id
                                        ? true
                                        : false
                                    }
                                    defaultValue={
                                      menu
                                        ? menu?.obj
                                            ?.einvoice_classification_code_id
                                        : null
                                    }
                                  />
                                </div>
                              )
                            }}
                          />
                        )
                      }}
                      name="einvoice_classification_code_id"
                      autoComplete="off"
                      control={itemControl}
                      multiline={true}
                      fullWidth
                      margin="dense"
                      ref={itemRegister}
                      required
                      defaultValue={
                        menu
                          ? menu?.obj?.einvoice_classification_code_id ??
                            menu?.obj?.ClassificationCodeID ??
                            classificationCodeID
                          : null
                      }
                      disabled={!selfBillStatus ? true : false}
                    />
                  )}

                {!HandlerLoading && (
                  <Controller
                    render={({ value, onChange }) => {
                      const ccOptions = getDepartmentListingByItemID
                      const selectedCC = ccOptions?.find(
                        x => x?.CostCentreID === menu?.obj?.CostCentreID
                      )
                      const defVal = !!itemWatch('CostCentreID')
                        ? getDepartmentListingByItemID?.find(
                            x => x?.CostCentreID === itemWatch('CostCentreID')
                          )
                        : null

                      return (
                        <Autocomplete
                          options={
                            ccOptions?.sort((a, b) => {
                              return a.Code.localeCompare(b.Code)
                            }) || []
                          }
                          getOptionLabel={option =>
                            `${option?.Code} | ${option?.Name}`
                          }
                          value={
                            !!disableDeptController
                              ? getDepartmentListingByItemID?.find(
                                  cc => cc?.IsDefault === true
                                )
                              : defVal
                          }
                          // value={
                          //   !!(
                          //     ccOptions?.length === 1 && ccOptions[0]?.IsDefault
                          //   )
                          //     ? ccOptions[0]
                          //     : selectedCC
                          // }
                          fullWidth
                          disableClearable={disableDeptController}
                          disabled={
                            readOnly() === true ? true : disableDeptController
                          }
                          onChange={(value, newValue: any, reason) => {
                            itemRegister('CostCentreID')
                            setValueItem('CostCentreID', newValue?.CostCentreID)
                            if (reason === 'clear') {
                              setValueItem('CostCentreID', '')
                            }
                          }}
                          renderOption={(props, option) => {
                            return (
                              <div>
                                <div>
                                  <span className="xsTitle">{props?.Code}</span>
                                </div>
                                <div className="desc">{props?.Name}</div>
                              </div>
                            )
                          }}
                          renderInput={(params: any) => {
                            return (
                              <div>
                                <TextField
                                  {...params}
                                  required
                                  label="Department"
                                  variant="standard"
                                  fullWidth
                                  name="CostCentreID"
                                  disabled={
                                    readOnly() === true
                                      ? true
                                      : disableDeptController
                                  }
                                  helperText={
                                    (itemWatch('CostCentreID') === '' ||
                                      itemWatch('CostCentreID') === undefined ||
                                      itemWatch('CostCentreID') === null) &&
                                    itemErrors?.CostCentreID?.message
                                  }
                                  error={
                                    (itemWatch('CostCentreID') === '' ||
                                      itemWatch('CostCentreID') === undefined ||
                                      itemWatch('CostCentreID') === null) &&
                                    itemErrors?.CostCentreID
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            )
                          }}
                        />
                      )
                    }}
                    name="CostCentreID"
                    autoComplete="off"
                    control={itemControl}
                    multiline={true}
                    fullWidth
                    margin="dense"
                    ref={itemRegister()}
                    required
                    disabled={
                      readOnly() === true ? true : disableDeptController
                    }
                    helperText={
                      (itemWatch('CostCentreID') === '' ||
                        itemWatch('CostCentreID') === undefined ||
                        itemWatch('CostCentreID') === null) &&
                      itemErrors?.CostCentreID?.message
                    }
                    error={
                      (itemWatch('CostCentreID') === '' ||
                        itemWatch('CostCentreID') === undefined ||
                        itemWatch('CostCentreID') === null) &&
                      itemErrors?.CostCentreID
                        ? true
                        : false
                    }
                    defaultValue={
                      menu?.obj?.CostCentreID ? menu?.obj?.CostCentreID : ''
                    }
                  />
                )}

                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: '5px',
                    paddingRight: '10px',
                    marginTop: '11px',
                  }}
                >
                  <Controller
                    as={<NumberFormat allowNegative={false} />}
                    required
                    value={qty}
                    margin="dense"
                    ref={itemRegister}
                    name="Quantity"
                    label="Qty"
                    decimalScale={4}
                    control={itemControl}
                    autoComplete="off"
                    fixedDecimalScale
                    thousandSeparator
                    id="standard-basic"
                    customInput={TextField}
                    onValueChange={e => {
                      handleQtyChange(e)
                    }}
                    helperText={itemErrors?.Quantity?.message}
                    error={itemErrors?.Quantity ? true : false}
                    disabled={readOnly() === true ? true : false}
                    defaultValue={menu?.obj ? menu?.obj?.Quantity : 0}
                  />
                </Grid>

                <Grid item xs={6} style={{ marginBottom: '5px' }}>
                  {!uomExcLoading && (
                    <Controller
                      render={({ value, onChange }) => {
                        const defVal = getUOMExchangeList?.filter(
                          x => x?.uomid === uomID
                        )[0]

                        return (
                          <Autocomplete
                            options={getUOMExchangeList || []}
                            getOptionLabel={option => `${option?.uomcode}`}
                            filterOptions={createFilterOptions({
                              stringify: option =>
                                option.uomcode + option.uomname,
                            })}
                            fullWidth
                            onChange={(value, newValue: any) => {
                              setUomID(newValue?.uomid)
                              // onChange(newValue?.uomid)
                              itemRegister('UOMID')
                            }}
                            disabled={readOnly() === true ? true : false}
                            renderOption={(props, option) => {
                              return (
                                <div>
                                  <div>
                                    <span className="xsTitle">
                                      {props?.uomcode}
                                    </span>
                                  </div>
                                  <div className="desc">{props?.uomname}</div>
                                </div>
                              )
                            }}
                            defaultValue={defVal}
                            renderInput={(params: any) => {
                              return (
                                <div>
                                  <TextField
                                    {...params}
                                    label="UOM"
                                    style={{ width: '100%' }}
                                    margin="normal"
                                    required
                                    helperText={itemErrors?.UOMID?.message}
                                    error={itemErrors?.UOMID ? true : false}
                                  />
                                </div>
                              )
                            }}
                          />
                        )
                      }}
                      label="UOM"
                      name="UOMID"
                      autoComplete="off"
                      control={itemControl}
                      multiline={true}
                      fullWidth
                      margin="normal"
                      ref={itemRegister}
                      // helperText={errors?.UOMID?.message}
                      // error={errors?.UOMID ? true : false}
                      defaultValue={menu?.obj?.UOMID}
                      required
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ marginBottom: '5px', paddingRight: '10px' }}
                >
                  <Controller
                    as={
                      <NumberFormat
                        allowNegative={
                          getItemByCompany?.find(
                            x => x?.ExpenseItemID === itemWatch('ExpenseItemID')
                          )?.IsSystem === true
                            ? true
                            : false
                        }
                        value={cost}
                        required
                        customInput={TextField}
                        thousandSeparator
                        decimalScale={4}
                        fixedDecimalScale
                        isNumericString
                        label="Unit Price"
                        disabled={
                          readOnly() === true &&
                          !getGeneralPurchasePolicy[0]?.GRNStatus
                            ? true
                            : false
                        }
                        onValueChange={e => {
                          setCost(e?.floatValue)
                          setValueItem('UnitPrice', e?.floatValue)
                          handleAmtChange(e)
                        }}
                      />
                    }
                    onChange={(value, newValue: any) => {
                      handleAmtChange(newValue)
                    }}
                    name="UnitPrice"
                    control={itemControl}
                    margin="dense"
                    required
                    helperText={itemErrors?.UnitPrice?.message}
                    error={itemErrors?.UnitPrice ? true : false}
                    ref={itemRegister}
                    defaultValue={menu?.obj?.UnitPrice ?? 0}
                  />
                </Grid>
                <Grid item xs={6} style={{ marginBottom: '5px' }}>
                  <TextField
                    name={`Amount`}
                    label="Base Amt"
                    value={amtNumStr(
                      baseAmount(Number(qty), Number(cost))
                    ).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    margin="dense"
                    ref={itemRegister}
                    style={{ color: 'white' }}
                    disabled
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: '5px',
                    paddingRight: '10px',
                  }}
                >
                  <Controller
                    as={
                      <TextField
                        margin="dense"
                        label="Tax Code"
                        required
                        SelectProps={{
                          renderValue: () => `${selectedTax?.Code}`,
                          onChange: event => {
                            handleTaxChange(event, taxEffectiveDate)
                            setValueItem(
                              'TaxSchemeID',
                              event?.target?.value.toString()
                            )
                            clearErrorsItem('TaxSchemeID')
                          },
                        }}
                        select
                      >
                        {taxSchemeInput?.map((tax, index) => (
                          <MenuItem
                            id="tax-select"
                            key={index}
                            value={tax?.TaxSchemeID}
                          >
                            <span className="text-noflow">{`${tax?.Code}`}</span>
                          </MenuItem>
                        ))}
                      </TextField>
                    }
                    select
                    name="TaxSchemeID"
                    autoComplete="off"
                    control={itemControl}
                    helperText={itemErrors?.TaxSchemeID?.message}
                    error={itemErrors?.TaxSchemeID ? true : false}
                    defaultValue={menu?.obj?.TaxSchemeID || ''}
                    ref={itemRegister()}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginBottom: '5px',
                  }}
                >
                  <TextField
                    name="TaxRate"
                    label="Tax Rate %"
                    value={amtStr(taxCodeRate)}
                    disabled
                    margin="normal"
                    style={{ marginTop: '5px' }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    as={<NumberFormat allowNegative={false} />}
                    thousandSeparator
                    customInput={TextField}
                    ref={itemRegister()}
                    control={itemControl}
                    margin="dense"
                    name="TaxAmt"
                    label="Tax Amount"
                    className="left"
                    onValueChange={e => {
                      handleTaxAmtChange(e?.floatValue)
                      setTaxAmt(e?.floatValue)
                    }}
                    value={taxAmt}
                    defaultValue={menu?.obj?.TaxAmt ?? taxAmt ?? 0}
                    decimalScale={2}
                    fixedDecimalScale
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    render={({ value, onChange }) => {
                      value = { docAmt }
                      return (
                        <TextField
                          label="Doc Amount"
                          value={amtStr(docAmt ?? menu?.obj?.DocAmt)}
                          InputProps={{
                            readOnly: true,
                            disableUnderline: true,
                          }}
                          className="right"
                          disabled
                        />
                      )
                    }}
                    disabled
                    margin="dense"
                    defaultValue={docAmt ?? menu?.obj?.DocAmt}
                    name="DocAmt"
                    ref={itemRegister()}
                    control={itemControl}
                  />
                </Grid>

                <ItemVoiceTextField
                  mounted={true}
                  required
                  label="Remark"
                  name="Remark"
                  value={itemVoiceRemark}
                  setValue={setValueItem}
                  record={itemRecord}
                  setRecord={setItemRecord}
                  control={itemControl}
                  controllerProps={{
                    error: itemErrors?.Remark ? true : false,
                    defaultValue: menu?.obj?.Remark,
                    helperText: itemErrors?.Remark?.message,
                    ref: itemRegister,
                    autoComplete: 'off',
                  }}
                />
              </div>

              <ErrorDialog
                errorDia={errorDia}
                setErrorDia={setErrorDia}
                errorMsg={errMsg}
                errorHeaderMsg={'Error!'}
              />
            </>
          ),
          footer: {
            actions:
              detailMode === 'add'
                ? [
                    closeFooterOption,
                    {
                      displayText: 'Confirm & New',
                      props: {
                        onClick: () => {
                          handleItemSubmit(data =>
                            onSubmit(
                              data,
                              docAmt,
                              qty,
                              cost,
                              baseAmount(Number(qty), Number(cost)),
                              menu?.index,
                              true
                            )
                          )()
                        },
                        variant: 'contained',
                        color: 'primary',
                        disabled: !!ExpenseItemLoading,
                      },
                    },
                    {
                      displayText: 'Confirm',
                      props: {
                        onClick: () => {
                          handleItemSubmit(data =>
                            onSubmit(
                              data,
                              docAmt,
                              qty,
                              cost,
                              baseAmount(Number(qty), Number(cost)),
                              menu?.index,
                              false
                            )
                          )()
                        },
                        variant: 'contained',
                        color: 'primary',
                        disabled: !!ExpenseItemLoading,
                      },
                    },
                  ]
                : [
                    closeFooterOption,
                    {
                      displayText: 'Confirm',
                      props: {
                        onClick: () => {
                          handleItemSubmit(data =>
                            onSubmit(
                              data,
                              docAmt,
                              qty,
                              cost,
                              baseAmount(Number(qty), Number(cost)),
                              menu?.index,
                              false
                            )
                          )()
                        },
                        variant: 'contained',
                        color: 'primary',
                        disabled: !!ExpenseItemLoading,
                      },
                    },
                  ],
          },
        }}
      />
    </>
  )
}
